import React, { useContext, useEffect } from "react"
import { Grid } from "@material-ui/core"
import AirportCityAutocomplete from "./AirportCityAutocomplete";
import AirportNameAutocomplete from "./AirportNameAutocomplete";
import AirportManualSearch from "./AirportManualSearch";
import AirportStateSelect from "./AirportStateSelect";
import { ControlledCheckBox } from '../../Core/Form/CheckBox';
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { airportSchema } from "../AirportStep";
import { QuoteContextStore } from "../../../context/QuoteContext/QuoteContext";
import { OrangeButton } from "../../Core/Buttons/OrangeButton";
import { FlowBackButton } from "../../Core/Buttons/FlowBackButton";
import AirportNotFoundCheckbox from "./AirportNotFoundCheckbox";

const AirportDetailsForm = ({submit}) => {
    const { airports } = useContext(QuoteContextStore)
    const form = useForm({mode: 'onBlur' ,defaultValues: {...airports[Object.keys(airports)[0]]}, resolver: yupResolver(airportSchema)});
    
    useEffect(() => {
        form.reset({...airports[Object.keys(airports)[0]]})
    }, [airports[Object.keys(airports)[0]]])

    return (
        <form onSubmit={form.handleSubmit(submit)}>
            <FormProvider {...form}>
                <Grid container item md={12} lg={9} spacing={4}>
                    <Grid item xs={12} md={4}>
                        <AirportStateSelect />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <AirportCityAutocomplete />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <AirportNameAutocomplete />
                    </Grid>
                    <Grid item>
                        <AirportNotFoundCheckbox />
                    </Grid>
                    <AirportManualSearch />
                </Grid>
            </FormProvider>
            <Grid className="margin-top-basic">
                <FlowBackButton />
                <OrangeButton type="submit">Save & Continue</OrangeButton>
            </Grid>
        </form>
    )
}

export default AirportDetailsForm;